import React from "react";
import {
  TextField,
  Typography,
} from "@mui/material";

interface FormTextFieldProps {
  label: string;
  name: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
}

const FormTextFieldClient: React.FC<FormTextFieldProps> = ({
  label,
  name,
  value,
  onChange,
  disabled = false,
}) => {

  return (
    <>
      <Typography ml={1} mb={-1}>
        {label}
      </Typography>
      <TextField
        margin="normal"
        fullWidth
        id={name}
        placeholder={`Digite o ${label}`}
        name={name}
        value={value}
        onChange={onChange}
        disabled={disabled}
        sx={{
          "& .MuiInputLabel-root.Mui-focused": {
            color: "#303030",
          },
          "& .MuiInputLabel-root": {
            borderColor: "#303030",
          },
          "& .MuiOutlinedInput-root": {
            borderRadius: 3,
            boxShadow: 6,
            "& fieldset": {
              borderColor: "#303030",
            },
          },
          "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
            {
              borderColor: "#303030",
            },
        }}
      />
    </>
  );
};

export default FormTextFieldClient;
